import Evee from "evee";
import EventBus from './EventBus';

class IOSAPI extends Evee {
    constructor() {
        super();

        try {
            // The interface is how we will send messages to the ios app
            this.interface = window.webkit.messageHandlers;
        } catch (e) {
            this.interface = null;
        }
        this.supported = this.interface != null;
        this.player = null;

        // The iosInterface will contain methods that are called from the ios app
        this.iosInterface = {};

        if (this.supported) {
            this.createBindings();
            this.send('bound', {})
        }
    }

    isSupported() {
        return this.supported;
    }

    createBindings() {
        this.iosInterface.log = (msg) => {
            console.log(msg);
        };
        let _this = this;

        this.iosInterface.trackEnded = () => {
            _this.emit('playback.end', {});
        };

        this.iosInterface.trackPaused = () => {
            _this.emit('playback.pause', {});
        };

        this.iosInterface.trackPlayed = () => {
            _this.emit('playback.start', {});
        };

        this.iosInterface.updateTrackLoading = (percent) => {
            _this.emit('playback.loading', {
                loaded: percent
            });
        };

        this.iosInterface.next = () => {
            _this.emit('controls.next', {});
        };

        this.iosInterface.prev = () => {
            _this.emit('controls.prev', {});
        };

        this.iosInterface.updateTrackPosition = (data) => {
            _this.emit('playback.position', data);
        };

    }

    resume() {
        console.log('IOSAPI: resume');
        this.send('resume', {});
    }

    pause() {
        console.log('IOSAPI: pause');
        this.send('pause', {});
    }

    stop() {
        console.log('IOSAPI: stop');
        this.send('stop', {});
    }

    seek(time) {
        console.log('IOSAPI: seek - '+time);
        this.send('seek', { time: time });
    }

    seekPercent(percent) {
        console.log('SEEK %', percent);
        let actual = percent / 100;
        this.send('seekPercent', { percent: actual });
    }

    setVolume(amount) {
        this.send('setVolume', { volume: amount })
    }

    playTrack(source, track) {
        console.log('IOSAPI: play track - '+source);
        this.send('playTrack', {
            format: 'mp3',
            src: source,
            track: track
        })
    }
    
    sendQueue(items) {
        console.log('IOSAPI: send queue');
        console.log(items);
        this.send('sendQueue', {
            items: items
        });
    }

    prepareNext(source) {
        this.send('prepareNext', {
            format: 'mp3',
            src: source,
        });
    }

    setAPIKey(key) {
        this.send('setApiKey', key)
    }

    getAPIKey(key) {
        this.send('setApiKey', key)
    }

    forgetAPIKey() {
        this.send('forgetApiKey', {})
    }

    send(handler, payload) {
        console.log('iOSAPI - Sending message', handler, payload);
        try {
            this.interface[handler].postMessage(payload);
            console.log("iOSAPI - " + handler + " sent");
        } catch (e) {
            console.log("iOSAPI - No handler set for " + handler);
        }
    }

    call(method, data) {
        console.log('iOSAPI - calling method', method, data);
        try {
            this.iosInterface[method](data);
            console.log("iOSAPI - Sent method " + method);
        } catch (e) {
            console.log("iOSAPI - No method " + method);
            console.log(e);
        }
    }

}

let instance = new IOSAPI();

export default instance



// WEBPACK FOOTER //
// ./src/IOSAPI.js